
export default {
  name: "StoreInfo",
  props: {
    storeInfo: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getServiceImgUrl(id) {
      return this.services.find(item => item.id == id)?.imgUrl
    }
  }
}
